module.exports = __webpack_public_path__ + "img/overlay.b1f1f645.png";